import { Spin } from "antd";
import { OverviewGroupSummary } from "Services/Api/Dashboard/Types";
import { renderScoreCell } from "./columns";
import styles from './GroupSummaryTable.module.scss';

const TableDataCard = ({ data, loading }: { data: OverviewGroupSummary, loading: boolean }) => {
    return <Spin spinning={loading} wrapperClassName={styles.loadingCard}>
        <div className={styles.cardMobileView}>
            <div className={styles.heading}>{data?.groupName || ''}</div>
            <div>
                <div className={styles.row}>
                    <div className={styles.label}>Phishing</div>
                    {renderScoreCell(data?.phishingScore ?? 0)}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>Training</div>
                    {renderScoreCell(data?.elearningScore ?? 0)}
                </div>

            </div>
        </div>
    </Spin>
}

export default TableDataCard;